export default __webpack_public_path__ + "static/media/too_much_messages.5657ae05.svg";